
"use client";

import FilterMultiSelectHome from "@components/filter/company/FilterMultiSelectHome";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Link from "next/link";
import { useEffect, useState } from "react";

export default function Hero5({ pages, allCategory, allProfession, allCity }) {
  const currentPageAide = pages.find(item => item.id === 64);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);

  const link1 = currentPageAide?.seo_permalink + "/" + "preposee-aux-beneficiaires";
  const link2 = currentPageAide?.seo_permalink + "/" + "aide-a-habillement";
  const link3 = currentPageAide?.seo_permalink + "/" + "entretien-menager";
  const link4 = currentPageAide?.seo_permalink + "/" + "infirmierere-auxiliaire";

  useEffect(() => {
    if (Object.keys(selectedServices).length > 0) {
      localStorage.setItem('selectedServices', JSON.stringify([selectedServices.value]));
    }
    if (selectedCities.length > 0) {
      localStorage.setItem('selectedCities', JSON.stringify(selectedCities));
    }
  }, [selectedServices, selectedCities]);
  return (
    <>
      <div className="pt-48 pb-32 border-b border-pgray-100 bg-pgray-50">
        <div className="container">
          <div className="">
            <div>
              <h1 style={{ maxWidth: "750px", margin: "auto" }} className="text-center lg:text-[42px] sm:text-[28px] font-semibold  lg:leading-[50px] sm:leading-[36px] wow animate__animated animate__fadeInUp ">
                Trouver l&apos;aide et les soins à domicile dont vous avez besoin !
              </h1>
            </div>

            <div className="text-center wow animate__animated animate__fadeInUp">
              <div className="items-center  sm:inline-flex my-3 ">
                <div className="mr-0 sm:mr-3 mb-3 sm:mb-0">
                  <FilterMultiSelectHome
                    data={[...allCategory, ...allProfession]}
                    placeholder="Services/profession"
                    propsStyle={{ width: '250px', height: "50px", }}
                    controlStyles={{
                      height: "50px",
                      borderRadius: "10px",
                    }}
                    handleChange={(e) => setSelectedServices(e)}
                  />
                </div>
                <div className="flex items-center gap-3">
                  <div style={{ width: "225px" }}>
                    <ReactSearchAutocomplete
                      items={allCity.map((item) => ({
                        id: item.id_villes,
                        name: item.title,
                      }))}
                      onSelect={(e) => setSelectedCities([e.id])}
                      autoFocus
                      styling={{ borderRadius: "0.75rem", height: "48px" }}
                      placeholder="Villes"
                      showIcon={false}
                    />
                  </div>

                  <Link
                    href={"/" + currentPageAide?.seo_permalink}
                    className="h-12 pt-3 text-white btn bg-primary-1000 hover:bg-primary-1000 transition duration-150  rounded-xl px-10"
                  >
                    Trouver
                  </Link>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center wow animate__animated animate__fadeInUp">
              <strong>Tendances de recherche : </strong>
              <a href={link1} className="hover:text-primary-1000 transition duration-300">  Préposé(e) aux bénéficiaires,</a>
              <a href={link2} className="hover:text-primary-1000 transition duration-300"> Aide à habillement,</a>
              <a href={link3} className="hover:text-primary-1000 transition duration-300"> Entretien ménager,</a>
              <a href={link4} className="hover:text-primary-1000 transition duration-300"> Infirmier(ère) auxiliaire</a>
            </div>

            {/*<div className="mt-24 max-w-3xl mx-auto wow animate__animated animate__fadeInUp">
              <BrandSlider3 />
  </div>*/}
          </div>
        </div>
      </div>
    </>
  );
}
